// eslint-disable-next-line no-shadow
export enum FontsEnum {
	INTER = 'INTER',
	ZODIAK = 'ZODIAK',
}
